import useModalsStore from "src/store/modalsStore";
import Modal from "../Modal/Modal";
import { QRCodeSVG } from "qrcode.react";
import {
  MdAccountBox,
  MdClose,
  MdOutlineArrowForward,
  MdShare,
} from "react-icons/md";
import { useTranslation } from "react-i18next";
import { ICON_SIZES } from "src/helpers/constants";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { motion } from "framer-motion";
import useCurrentUser from "src/hooks/useCurrentUser";
import clsx from "clsx";
import { EButtonKind } from "../Button/ButtonTypes";

const CurrentUserQrContact: React.FC = () => {
  const { setShowContactQrCode } = useModalsStore();
  const { userInfo } = useCurrentUser();
  const location = useLocation();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const qrValue = useMemo(
    () =>
      [
        "BEGIN:VCARD",
        "VERSION:2.1",
        `N:${userInfo?.name};`,
        `FN:${userInfo?.name}`,
        `EMAIL:${userInfo?.email}`,
        `TEL;TYPE=cell:${userInfo?.mobile}`,
        "END:VCARD",
      ].join("\r\n"),
    [userInfo]
  );

  return (
    <Modal
      onEscape={() => setShowContactQrCode(false)}
      className="md:!max-w-[400px] md:!w-full"
    >
      <Modal.Header
        title={t("Compartir datos de contacto")}
        onClose={() => setShowContactQrCode(false)}
      />
      <Modal.Body>
        <div
          className={clsx([
            "flex",
            "flex-col",
            "items-center",
            "justify-center",
            "gap-4",
          ])}
        >
          <p className="text-sm">
            {t(
              "Escanea éste código QR con la cámara del teléfono para compartir tus datos de contacto fácilmente."
            )}
          </p>
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            className={clsx(["flex", "justify-center", "items-center"])}
            transition={{
              duration: 0.5,
              ease: "easeOut",
            }}
          >
            <QRCodeSVG
              value={qrValue}
              title="eXpenser.net"
              fgColor="#212f3c"
              height={180}
              width={180}
              level="L"
            />
          </motion.div>
          <p className="text-sm">
            {t(
              "El código QR incluye tu nombre, dirección física y todos los datos de contacto que configuraste en tu perfil."
            )}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("shared.close"),
            icon: <MdClose size={ICON_SIZES.MD} />,
            onClick: () => setShowContactQrCode(false),
            kind: EButtonKind.NORMAL,
          },
        ]}
        leftContent={
          <ButtonGroup
            gap={1}
            align="left"
            buttons={[
              {
                tooltip: t("shared.share"),
                onClick: () => {},
                icon: <MdShare size={ICON_SIZES.MD} />,
                kind: EButtonKind.NORMAL,
              },
              {
                tooltip: t("Perfil"),
                onClick: () => {
                  setShowContactQrCode(false);
                  navigate("/settings/profile");
                },
                icon: <MdOutlineArrowForward size={ICON_SIZES.MD} />,
                hide: location.pathname.startsWith("/settings/profile"),
              },
            ]}
          />
        }
      />
    </Modal>
  );
};

export default CurrentUserQrContact;
